import router from './router'
import store from '@/store'

const whiteList = ['/', '/bookshelf']

router.beforeEach(async(to, from, next) => {
  if (to.meta.noLogin) {
    next()
    return
  }
  store.dispatch('updateBookList').then(() => {
    const hasToken = store.getters.token
    const usessionid = store.getters.usessionid
    if (whiteList.indexOf(to.path) !== -1) { // 白名单时如果要登录下usessionid拿到用户信息，拿不到删掉usessionid
      if (usessionid && usessionid !== '' && usessionid !== 'undefined') {
        store.dispatch('getInfo').then(() => {
          next()
        }).catch(() => {
          next()
        })
      } else {
        next()
      }
      return
    }
    if (hasToken && hasToken !== '' && hasToken !== 'undefined') {
      if (usessionid && usessionid !== '' && usessionid !== 'undefined') {
        const restoken = store.getters.restoken
        if (restoken && restoken !== '') {
          next()
        } else {
          store.dispatch('getInfo').then(() => {
            next()
          })
        }
      } else {
        window.location.href = 'login.html?re=' + encodeURIComponent(window.location.href)
      }
    } else { // 没有token的情况下先去获得token
      store.dispatch('getApiToken').then(() => {
        router.push(to.path)
      })
    }
  })
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/modules/pc/permission.js